import React from "react";
import styled from "styled-components";

export default function Introduction() {
  return (
    <Styles>
      <h1>Simple and fast api client for ProFile.</h1>

      <p style={{ marginTop: "4rem" }}>
        <strong>Minibeak helps you:</strong>
      </p>
      <ul>
        <li>Construct and perform HTTP requests against ProFile's json-api</li>
        <li>Process responses from ProFile's json-api</li>
        <li>Use ProFile's json-api from React</li>
      </ul>

      <p style={{ marginTop: "3rem" }}>
        <strong>Differences from Kolibri resources:</strong>
      </p>

      <ul>
        <li>Much faster</li>
        <li>No immutablejs</li>
        <li>Plain JS, supports circular resource links</li>
        <li>No central resource store</li>
        <li>No Redux</li>
        <li>No action binding</li>
        <li>
          Based on{" "}
          <a href="https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch">
            HTML5 fetch
          </a>
        </li>
      </ul>

      <p style={{ marginTop: "3rem" }}>
        <strong>Should you use minibeak instead of Kolibri resources?</strong>
      </p>

      <ul>
        <li>
          Yes if you have performance issues because of processing thousands of
          resources.
        </li>
        <li>Just decide something or ask your favorite source of authority.</li>
        <li>May the spirit of the beak be with you.</li>
      </ul>

      <div className="badges">
        <p>Npm package:</p>
        <a href="https://www.npmjs.com/package/@dossier/minibeak">
          <img
            src="https://img.shields.io/npm/v/@dossier/minibeak?label=%40dossier%2Fminibeak"
            alt="npm package"
          />
        </a>
        <p>Documentation build:</p>
        <a href="https://app.netlify.com/sites/minibeak/deploys">
          <img
            src="https://api.netlify.com/api/v1/badges/8b7b0ec2-5b70-4aa0-8af7-fc308b2d4b77/deploy-status"
            alt="Netlify deploy status"
          />
        </a>

        <p>
          <a href="https://bitbucket.org/dossiersolutions/minibeak/src/master/src/">
            Contribute on Bitbucket
          </a>
        </p>
      </div>
    </Styles>
  );
}

const Styles = styled.div`
  .badges {
    margin: 4em 0;
    a {
      display: block;
    }
  }
`;
